var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoProcurement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_451_2697)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_451_2697)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 33,
    width: 44,
    height: 71,
    rx: 4,
    fill: "white",
    fillOpacity: 0.65,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_451_2697)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 44,
    width: 45,
    height: 57,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 66,
    width: 35,
    height: 5,
    rx: 2.5,
    fill: "#EAEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 74,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#EAEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 51,
    width: 13,
    height: 11,
    rx: 1,
    fill: "#EFF0F0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_451_2697)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 44,
    r: 8,
    fill: "#F73C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.98 46.84C83.5 47.3467 82.8833 47.6 82.13 47.6C81.3767 47.6 80.76 47.3467 80.28 46.84C79.8 46.3267 79.56 45.67 79.56 44.87V43.01C79.56 42.21 79.8 41.5567 80.28 41.05C80.76 40.5367 81.3767 40.28 82.13 40.28C82.8833 40.28 83.5 40.5367 83.98 41.05C84.4667 41.5567 84.71 42.21 84.71 43.01V44.87C84.71 45.67 84.4667 46.3267 83.98 46.84ZM82.13 46.52C82.5767 46.52 82.9333 46.3733 83.2 46.08C83.4733 45.7867 83.61 45.3833 83.61 44.87V43.01C83.61 42.4967 83.4733 42.0933 83.2 41.8C82.9333 41.5067 82.5767 41.36 82.13 41.36C81.69 41.36 81.3333 41.5067 81.06 41.8C80.7933 42.0933 80.66 42.4967 80.66 43.01V44.87C80.66 45.3833 80.7933 45.7867 81.06 46.08C81.3333 46.3733 81.69 46.52 82.13 46.52Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_451_2697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3338 21.8052L23.213 23.4537L24.8615 24.333L23.213 25.2122L22.3338 26.8607L21.4545 25.2122L19.806 24.333L21.4545 23.4537L22.3338 21.8052ZM16.3338 23.8885L18.1115 27.2218L21.4449 28.9996L18.1115 30.7774L16.3338 34.1107L14.556 30.7774L11.2227 28.9996L14.556 27.2218L16.3338 23.8885ZM24.1115 31.8885L23.0005 29.8052L21.8893 31.8885L19.806 32.9996L21.8893 34.1107L23.0005 36.194L24.1115 34.1107L26.1949 32.9996L24.1115 31.8885Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_451_2697",
    x: 14,
    y: 30,
    width: 52,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.36 0 0 0 0 0.408 0 0 0 0 0.44 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_451_2697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_451_2697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_451_2697",
    x: 24,
    y: 32,
    width: 77,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.36 0 0 0 0 0.408 0 0 0 0 0.44 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_451_2697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_451_2697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_451_2697",
    x: 70,
    y: 34,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_451_2697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_451_2697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_451_2697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_451_2697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11 21)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProcurement);
export default __webpack_public_path__ + "static/media/no-procurement.0b3fa9a8c9e799829a6a587b7630e202.svg";
export { ForwardRef as ReactComponent };